// extracted by mini-css-extract-plugin
export default {"wrapper":"VerticalTabs_wrapper__-+e0J","content":"VerticalTabs_content__0s15n"};